import { Component, OnInit, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { Invoice } from '../../models/invoice';
import { DateUtilService } from 'gung-common';
import { InvoiceActionConfigService } from '../../services/invoice-action-config/invoice-action-config.service';
import { InvoiceListConfigService } from '../../services/invoice-list-config/invoice-list-config.service';

@Component({
    selector: 'lib-invoice-table',
    templateUrl: './invoice-table.component.html',
    styleUrls: ['./invoice-table.component.css'],
    standalone: false
})
export class InvoiceTableComponent extends ListItemRendererComponent<Invoice[]> implements OnInit, AfterViewInit {
  constructor(
    public dateUtilService: DateUtilService,
    public actionConfigService: InvoiceActionConfigService,
    protected invoiceListConfigService: InvoiceListConfigService
  ) {
    super();
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }
}
